import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Loading } from './components/Loading';
import SchoolListPage from './school/SchoolListPage';
//import { useAppConfig } from '../utils/hooks/useAppConfig';
import { useAppConfig } from 'utils/hooks/useAppConfig';
import { SchoolApp } from './SchoolApp';
// import { useSelector } from 'react-redux';
// import moment from 'moment';
import { ByeBye } from './ByeBye';

const App = () => {
    const appReady = useAppConfig();
    // const config = useSelector(state => state.config);
    if (!appReady) return null;

    // if ((config.serviceCode === 'gne' && (!config.useService || moment().year > 2024))) {
    //     return <ByeBye />
    // }

    return (
        <Routes>
            <Route path="/bye" element={<ByeBye />} />
            <Route path="/" element={<SchoolListPage />} />
            <Route path="/:school/*" element={
                <Suspense fallback={<Loading />}>
                    <SchoolApp />
                </Suspense>
            } />
        </Routes>
    );

}

export default App;